export default __webpack_public_path__ + "static/media/upee_distribution_a.28b78132.webp";